<template>
    <div class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header :header-type="'shop'"></main-header>

        <!-- 메인 -->
        <main class="main" role="main">
            <!-- 상품 리스트 -->
            <section class="product-lists">
                <div class="inner">
                    <!-- 상품 리스트 시작 -->
                    <div class="center-title">
                        <h2>새집처럼 <b>베스트</b></h2>
                        <horizontal-slide v-model="filter._category" @input="search"></horizontal-slide>
                    </div>
                    <div class="product-lists__body">
                        <div class="grid rank">
                            <div v-for="{ product } in exhibitions" :key="product._id" class="grid-6">
                                <router-link class="product-list" :to="`/shop/products/${product._id}`">
                                    <span class="product-list__thumb">
                                        <span class="product-list__thumbnail">
                                            <span class="product-list__thumbnail-image" :style="{ backgroundImage: `url('${product.thumb}')` }"></span>
                                        </span>
                                        <span class="product-list__thumb-image"></span>
                                    </span>
                                    <span class="product-list__brand">{{ (product.user || {}).name }}</span>
                                    <span class="product-list__title">{{ product.name }}</span>
                                    <span class="product-list__price">
                                        <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.discountRate }}%</span>
                                        <em class="product-list__price-num">{{ product.salePrice.format() }}원</em>
                                        <span v-if="product.discountEnabled" class="product-list__price-line">{{ product.price.format() }}</span>
                                    </span>
                                </router-link>
                            </div>
                        </div>

                        <div class="product-lists__pagination">
                            <pagination-component v-model="page" :count="pageCount" @input="search($route.query)"></pagination-component>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import HorizontalSlide from "@/components/client/shop/horizontal-slide.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
    components: {
        MainHeader,
        MainFooter,
        HorizontalSlide,
        PaginationComponent,
    },
    data() {
        return {
            filter: {
                _category: this.$route.query._category,
                code: "best",
            },

            exhibitions: [],

            page: +this.$route.query.path || 1,
            pageCount: 0,
            limit: 20,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                this.search(false);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, { _category: this.filter._category, page: this.page }),
                    });
                }

                var { summary, exhibitions } = await api.v1.shop.exhibitions.getExhibitions({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.exhibitions = exhibitions;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>
